<template>
  <b-row class="align-items-end">
    <b-col>
      <legend class="col-form-label pt-0">
        Funil
      </legend>

      <b-select
        :value="funilSelecionado"
        name="funilSelecao"
        class="search-items"
        @change="onFunilChange"
      >
        <option
          v-for="funil in funis"
          :key="funil.id"
          :value="funil.id"
        >
          {{ funil.name }}
        </option>
      </b-select>
    </b-col>

    <b-col
      cols="5"
      class="d-flex justify-content-end flex-wrap"
    >
      <cadastro-funil
        class="mr-50"
        @funil-criado="$emit('refresh-funil')"
      />
      <b-btn
        class="btn-primary btn-sm mr-50"
        @click="abrirModalCadastroEtapa"
      >
        <font-awesome-icon :icon="faPlus" />
        Nova etapa
      </b-btn>
      <b-btn
        class="btn-primary btn-sm mr-50"
        @click="abrirModalCadastroOportunidade"
      >
        <font-awesome-icon :icon="faPlus" />
        Nova Jornada
      </b-btn>
    </b-col>

    <modal-criar-pessoa
      ref="modalCriarPessoa"
      :empresa-id="empresaSelecionadaId"
      @pessoa-criada="pessoaCriada"
    />
    <modal-cadastro-oportunidade
      ref="modalCadastroOportunidade"
      :funis="funis"
      :funil-selecionado="funilSelecionado"
      @oportunidade-criada="$emit('oportunidade-criada', $event)"
      @solicitar-criacao-pessoa="abrirModalCriarPessoa"
      @empresa-atualizada="onNovaOportunidadeCompanyChanged"
    />
    <modal-cadastro-etapa
      ref="modalCadastroEtapa"
      :funil-selecionado="funilSelecionado"
      @etapa-criada="$emit('etapa-criada', $event)"
    />
  </b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'PainelOportunidadesHeader',
  components: {
    FontAwesomeIcon,
    CadastroFunil: () => import('@/app-modulo/comercial/oportunidades/shared/components/cadastro-funil/CadastroFunil.vue'),
    ModalCriarPessoa: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/modal-criar-pessoa/ModalCriarPessoa.vue'),
    ModalCadastroOportunidade: () => import('@/app-modulo/comercial/oportunidades/shared/components/modal-cadastro-oportunidade/ModalCadastroOportunidade.vue'),
    ModalCadastroEtapa: () => import('@/app-modulo/comercial/oportunidades/shared/components/modal-cadastro-etapa/ModalCadastroEtapa.vue'),
  },
  props: {
    funis: {
      type: Array,
      default: () => [],
    },
    funilSelecionado: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['funil-change', 'funil-criado', 'oportunidade-criada', 'etapa-criada'],
  data() {
    return {
      faPlus,
      empresaSelecionadaId: null,
    }
  },
  methods: {
    onFunilChange(value) {
      this.$emit('funil-change', value)
    },
    async pessoaCriada(pessoaData) {
      if (this.$refs.modalCadastroOportunidade?.pessoaCriada) {
        await this.$refs.modalCadastroOportunidade.pessoaCriada(pessoaData)
      }
      if (this.$sucesso) this.$sucesso('Pessoa criada com sucesso!')
    },
    abrirModalCriarPessoa(empresaId = null) {
      if (empresaId !== null && empresaId !== undefined) {
        this.empresaSelecionadaId = empresaId
      }
      if (this.$refs.modalCriarPessoa?.show) {
        this.$refs.modalCriarPessoa.show()
      }
    },
    abrirModalCadastroOportunidade() {
      if (this.$refs.modalCadastroOportunidade) this.$refs.modalCadastroOportunidade.showModal()
    },
    abrirModalCadastroEtapa() {
      if (this.$refs.modalCadastroEtapa?.show) this.$refs.modalCadastroEtapa.show()
    },
    onNovaOportunidadeCompanyChanged(empresa) {
      this.empresaSelecionadaId = empresa && empresa.id ? empresa.id : null
    },
  },
}
</script>
